






// @ is an alias to /src

import { Vue, Component } from "vue-property-decorator";
import OrganizationModel from "@/model/Organization";
import ModelFactory from "@/model/ModelFactory";
import ReportApi from "@/api/Report";

import SummaryHcoList from "@/components/Summary/HcoList.vue";

import { SummaryServerResponse } from "@/types/global.d";

@Component({
  components: {
    SummaryHcoList
  }
})
export default class HcoListView extends Vue {
  public organizations: OrganizationModel[] = [];

  mounted() {
    this.getData();
  }

  async getData(year?: number) {
    const { organizations } = await ReportApi.getReportByYear(year).then(
      (res: SummaryServerResponse) => {
        return {
          report: ModelFactory.create("ReportModel", res.object.summary),
          organizations: ModelFactory.create(
            "OrganizationModel",
            res.object.details
          )
        };
      }
    );
    this.organizations = organizations;
  }
}
